// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IIndividualDeductibleUpdateRequestDto } from './IIndividualDeductibleUpdateRequestDto';
import {
    IIndividualDeductibleUpdateRequestDtoFromJSON,
    IIndividualDeductibleUpdateRequestDtoFromJSONTyped,
    IIndividualDeductibleUpdateRequestDtoToJSON,
    IIndividualDeductibleUpdateRequestDtoToJSONTyped,
} from './IIndividualDeductibleUpdateRequestDto';

/**
 * 
 * @export
 * @interface IDeductiblePreviewRequestDto
 */
export interface IDeductiblePreviewRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IDeductiblePreviewRequestDto
     */
    health_policy_id: number;
    /**
     * 
     * @type {number}
     * @memberof IDeductiblePreviewRequestDto
     */
    family_deductible_amount: number;
    /**
     * 
     * @type {Array<IIndividualDeductibleUpdateRequestDto>}
     * @memberof IDeductiblePreviewRequestDto
     */
    individual_deductibles?: Array<IIndividualDeductibleUpdateRequestDto>;
}

/**
 * Check if a given object implements the IDeductiblePreviewRequestDto interface.
 */
export function instanceOfIDeductiblePreviewRequestDto(value: object): value is IDeductiblePreviewRequestDto {
    if (!('health_policy_id' in value) || value['health_policy_id'] === undefined) return false;
    if (!('family_deductible_amount' in value) || value['family_deductible_amount'] === undefined) return false;
    return true;
}

export function IDeductiblePreviewRequestDtoFromJSON(json: any): IDeductiblePreviewRequestDto {
    return IDeductiblePreviewRequestDtoFromJSONTyped(json, false);
}

export function IDeductiblePreviewRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDeductiblePreviewRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'health_policy_id': json['health_policy_id'],
        'family_deductible_amount': json['family_deductible_amount'],
        'individual_deductibles': json['individual_deductibles'] == null ? undefined : ((json['individual_deductibles'] as Array<any>).map(IIndividualDeductibleUpdateRequestDtoFromJSON)),
    };
}

export function IDeductiblePreviewRequestDtoToJSON(json: any): IDeductiblePreviewRequestDto {
    return IDeductiblePreviewRequestDtoToJSONTyped(json, false);
}

export function IDeductiblePreviewRequestDtoToJSONTyped(value?: IDeductiblePreviewRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'health_policy_id': value['health_policy_id'],
        'family_deductible_amount': value['family_deductible_amount'],
        'individual_deductibles': value['individual_deductibles'] == null ? undefined : ((value['individual_deductibles'] as Array<any>).map(IIndividualDeductibleUpdateRequestDtoToJSON)),
    };
}

